import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { buildQueryString, exportFile, showError } from "../../utils/utilities";
import { useFormik } from "formik";
import { cloneDeep, get, isEmpty, toLower } from "lodash";
import { useTranslation } from "react-i18next";
import { dbDate, fileFormatXextension, langDate } from "../../utils/properties";
import { Col, Row, Select, DatePicker } from "antd";
import { DownloadOutlined, ClearOutlined } from "@ant-design/icons";
import Button from "../../components/functional_components/Button/PFButton";
import { setLoading } from "../../redux/ducks/Loading";
import ExpenseRefund from "../../services/api/ExpenseRefund";
import dayjs from "dayjs";
import User from "../../services/api/User";
const { Option } = Select;

const ExportReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const dateFormat = langDate[toLower(currentLanguage)];
  const [state] = useState({
    suppliersOptionsList: [],
    filterLoading: false,
  });
  const [findUsers, setFindUsers] = useState([]);
  const formikFilter = useFormik({
    initialValues: {
      dateApprovalFrom: null,
      dateApprovalTo: null,
      // dateSendApprovalFrom: null,
      // dateSendApprovalTo: null,
      docDateFrom: null,
      docDateTo: null,
      username: null,
      status: [],
      types: [],
    },
    // validate: values => {
    //   let errors = {};
    //   if (!values.month) {
    //     errors.month = "Required!"
    //   }
    //   return errors;
    // },
    enableReinitialize: true,
    validate: (values) => {
      let errors = {};
      if (values.dateApprovalFrom && values.dateApprovalTo && values.dateApprovalFrom > values.dateApprovalTo) {
        errors.dateApprovalFrom = "Date approval from must be before date approval to";
        errors.dateApprovalTo = "Date approval from must be before date approval to";
      }
      if (values.docDateFrom && values.docDateTo && values.docDateFrom > values.docDateTo) {
        errors.docDateFrom = "Doc date from must be before doc date to";
        errors.docDateTo = "Doc date from must be before doc date to";
      }
      return errors;
    },
    onSubmit: async (values) => {
      dispatch(setLoading(true));
      const filterSubmit = cloneDeep(values);
      // if (filterSubmit.dateSendApprovalFrom) {
      //   filterSubmit.dateSendApprovalFrom = dayjs(filterSubmit.dateSendApprovalFrom, dateFormat).format(dbDate);
      // } else {
      //   delete filterSubmit.dateSendApprovalFrom;
      // }
      // if (filterSubmit.dateSendApprovalTo) {
      //   filterSubmit.dateSendApprovalTo = dayjs(filterSubmit.dateSendApprovalTo, dateFormat).format(dbDate);
      // } else {
      //   delete filterSubmit.dateSendApprovalTo;
      // }
      if (filterSubmit.dateApprovalFrom) {
        filterSubmit.dateApprovalFrom = dayjs(filterSubmit.dateApprovalFrom, dateFormat).format(dbDate);
      } else {
        delete filterSubmit.dateApprovalFrom;
      }
      if (filterSubmit.dateApprovalTo) {
        filterSubmit.dateApprovalTo = dayjs(filterSubmit.dateApprovalTo, dateFormat).format(dbDate);
      } else {
        delete filterSubmit.dateApprovalTo;
      }
      if (filterSubmit.docDateFrom) {
        filterSubmit.docDateFrom = dayjs(filterSubmit.docDateFrom, dateFormat).format(dbDate);
      } else {
        delete filterSubmit.docDateFrom;
      }
      if (filterSubmit.docDateTo) {
        filterSubmit.docDateTo = dayjs(filterSubmit.docDateTo, dateFormat).format(dbDate);
      } else {
        delete filterSubmit.docDateTo;
      }
      if (isEmpty(filterSubmit.status)) {
        delete filterSubmit.status;
      }
      if (isEmpty(filterSubmit.types)) {
        delete filterSubmit.types;
      }
      if (!filterSubmit.username) {
        delete filterSubmit.username;
      }
      const queryString = buildQueryString(filterSubmit, {});
      const exportResponse = await ExpenseRefund.getExpenseRefundExport(queryString.string);
      if (exportResponse) {
        if (!exportResponse.error) {
          const downloadType = fileFormatXextension["xlsx"];
          const blob = new Blob([exportResponse], { type: downloadType });
          exportFile(blob, "expense-refund-report.xlsx");
        } else {
          showError(get(exportResponse, "error.messageCode", "ER000"));
        }
      }
      dispatch(setLoading(false));
    },
  });

  async function onSearchusers(value) {
    if (value.length >= 2) {
      const { error, data } = await User.getUsersInternalList(`allPages=true&surname=${value}`);
      if (!error && data) {
        setFindUsers(data.map((u) => ({ value: u.username, label: `${u.name} ${u.surname}` })));
      }
    }
  }
  return (
    <div className="filter-container">
      <Row gutter={[48, 32]} align="bottom">
        <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("expenseRefundFolder.exportReport.dateApprovalFrom")}</label>
          </Row>
          <Row>
            <DatePicker
              id="dateApprovalFrom"
              name="dateApprovalFrom"
              format={dateFormat}
              locale={langDate[`locale_${toLower(currentLanguage)}`]}
              value={formikFilter.values.dateApprovalFrom}
              onChange={(date) => formikFilter.setFieldValue("dateApprovalFrom", date)}
              onBlur={() => formikFilter.validateForm()}
              className={formikFilter.errors.dateApprovalFrom !== undefined && "input-error"}
            />
          </Row>
        </Col>
        <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("expenseRefundFolder.exportReport.dateApprovalTo")}</label>
          </Row>
          <Row>
            <DatePicker
              id="dateApprovalTo"
              name="dateApprovalTo"
              format={dateFormat}
              locale={langDate[`locale_${toLower(currentLanguage)}`]}
              value={formikFilter.values.dateApprovalTo}
              onChange={(date) => formikFilter.setFieldValue("dateApprovalTo", date)}
              onBlur={() => formikFilter.validateForm()}
              className={formikFilter.errors.dateApprovalTo !== undefined && "input-error"}
            />
          </Row>
        </Col>
        {/* <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("expenseRefundFolder.exportReport.dateSendApprovalFrom")}</label>
          </Row>
          <Row>
            <DatePicker
              id="dateSendApprovalFrom"
              name="dateSendApprovalFrom"
              format={dateFormat}
              locale={langDate[`locale_${toLower(currentLanguage)}`]}
              value={formikFilter.values.dateSendApprovalFrom}
              onChange={(date) => formikFilter.setFieldValue("dateSendApprovalFrom", date)}
            />
          </Row>
        </Col> */}
        {/* <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("expenseRefundFolder.exportReport.dateSendApprovalTo")}</label>
          </Row>
          <Row>
            <DatePicker
              id="dateSendApprovalTo"
              name="dateSendApprovalTo"
              format={dateFormat}
              locale={langDate[`locale_${toLower(currentLanguage)}`]}
              value={formikFilter.values.dateSendApprovalTo}
              onChange={(date) => formikFilter.setFieldValue("dateSendApprovalTo", date)}
            />
          </Row>
        </Col> */}
        <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">
              {t("expenseRefundFolder.exportReport.user") + " " + t("expenseRefundFolder.exportReport.userLabelInfo")}
            </label>
          </Row>
          <Row>
            <Select
              showSearch
              allowClear
              className="w-100"
              id="username"
              name="username"
              placeholder={t("fuelCard.table.user")}
              onChange={(s) => formikFilter.setFieldValue("username", s)}
              onBlur={formikFilter.handleBlur("username")}
              value={formikFilter.values.username}
              onSearch={onSearchusers}
              options={findUsers}
            />
          </Row>
        </Col>
        <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("expenseRefundFolder.exportReport.docDateFrom")}</label>
          </Row>
          <Row>
            <DatePicker
              id="docDateFrom"
              name="docDateFrom"
              format={dateFormat}
              locale={langDate[`locale_${toLower(currentLanguage)}`]}
              value={formikFilter.values.docDateFrom}
              onChange={(date) => formikFilter.setFieldValue("docDateFrom", date)}
              onBlur={() => formikFilter.validateForm()}
              className={formikFilter.errors.docDateFrom !== undefined && "input-error"}
            />
          </Row>
        </Col>
        <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("expenseRefundFolder.exportReport.docDateTo")}</label>
          </Row>
          <Row>
            <DatePicker
              id="docDateTo"
              name="docDateTo"
              format={dateFormat}
              locale={langDate[`locale_${toLower(currentLanguage)}`]}
              value={formikFilter.values.docDateTo}
              onChange={(date) => formikFilter.setFieldValue("docDateTo", date)}
              onBlur={() => formikFilter.validateForm()}
              className={formikFilter.errors.docDateTo !== undefined && "input-error"}
            />
          </Row>
        </Col>
        {/*force status to go to next line */}
        <Col span={8}></Col>
        <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("expenseRefundFolder.exportReport.status")}</label>
          </Row>
          <Row>
            <Select
              allowClear
              mode="multiple"
              className="w-100"
              id="status"
              name="status"
              placeholder={t("expenseRefundFolder.exportReport.status")}
              onChange={(s) => {
                formikFilter.setFieldValue("status", s);
              }}
              onBlur={formikFilter.handleBlur}
              value={formikFilter.values.status}
            >
              {[
                "APPROVED",
                "PLANNING",
                "REFUTED",
                "WAITING_APPROVAL_1",
                "WAITING_APPROVAL_2",
                "WAITING_APPROVAL_3",
              ].map((data, idx) => {
                return (
                  <Option key={idx} value={data} name={data}>
                    {t(`projects.status.${toLower(data)}`)}
                  </Option>
                );
              })}
            </Select>
          </Row>
        </Col>
        <Col span={8}>
          <Row justify="start">
            <label className="fw-bold mt-10">{t("expenseRefundFolder.exportReport.type")}</label>
          </Row>
          <Row>
            <Select
              allowClear
              mode="multiple"
              className="w-100"
              id="types"
              name="types"
              placeholder={t("expenseRefundFolder.exportReport.type")}
              onChange={(s) => {
                formikFilter.setFieldValue("types", s);
              }}
              onBlur={formikFilter.handleBlur}
              value={formikFilter.values.types}
            >
              {["JUSTIFICATION", "FLAT_RATE", "KM", "CREDIT_CARD"].map((data, idx) => {
                return (
                  <Option key={idx} value={data} name={data}>
                    {t(`expenseRefundFolder.exportReport.optionsType.${toLower(data)}`)}
                  </Option>
                );
              })}
            </Select>
          </Row>
        </Col>
        <Col span={8}>
          <Row justify="end">
            <Col>
              <Button
                type="secondary"
                currentSize="large"
                clickCallback={formikFilter.resetForm}
                currentIcon={<ClearOutlined className="icon-large" />}
              />
            </Col>
            <Col className="left-margin">
              <Button
                currentSize="large"
                isLoading={state.filterLoading}
                clickCallback={formikFilter.submitForm}
                currentIcon={<DownloadOutlined className="icon-large" />}
                isDisabled={!formikFilter.isValid}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ExportReport;
